export const hexToRgba = (hex: string, opacity = 1) => {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)

    const rgb = {
        // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
        r: parseInt(result[1], 16),
        // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
        g: parseInt(result[2], 16),
        // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
        b: parseInt(result[3], 16),
    }
    return `rgba(${rgb.r},${rgb.g},${rgb.b}, ${opacity})`
}
